// extracted by mini-css-extract-plugin
module.exports = {"sub__text":"style_sub__text__1yzcG","document-card":"style_document-card__1soKS"};